import React from "react";

const SvgVazbyVyhledavani = props => (
	<svg viewBox="0 0 363.53 363.53" {...props}>
		<g id="Vrstva_2" data-name="Vrstva 2">
			<g id="Boční_menu" data-name="Boční menu">
				<g id="Vazby_vyhledavani" data-name="Vazby vyhledavani">
					<path d="M279.42,333.62a7.5,7.5,0,0,1-4.21-13.71c2.86-1.93,5.71-4,8.47-6.14a7.5,7.5,0,1,1,9.19,11.86c-3,2.34-6.13,4.59-9.25,6.7A7.49,7.49,0,0,1,279.42,333.62Z" />
					<path d="M181.77,363.53C81.54,363.53,0,282,0,181.76S81.54,0,181.77,0,363.53,81.54,363.53,181.76a181.53,181.53,0,0,1-45.69,120.52,7.5,7.5,0,0,1-11.23-9.95,166.54,166.54,0,0,0,41.92-110.57C348.53,89.81,273.72,15,181.77,15S15,89.81,15,181.76,89.81,348.53,181.77,348.53a165.49,165.49,0,0,0,67.57-14.25A7.5,7.5,0,1,1,255.43,348,180.55,180.55,0,0,1,181.77,363.53Z" /><path d="M282.23,331.67a7.5,7.5,0,0,1-4.51-13.49l4.55-3.42a7.5,7.5,0,1,1,9,12l-4.55,3.42A7.49,7.49,0,0,1,282.23,331.67Z" /><path d="M280.66,280.66a7.47,7.47,0,0,1-5.27-2.16L215.15,219a7.5,7.5,0,1,1,10.54-10.67l60.24,59.5a7.5,7.5,0,0,1-5.27,12.84ZM153.61,226a78,78,0,0,1-55-22.54h0a78.32,78.32,0,1,1,55,22.54Zm-44.44-33.21a63.23,63.23,0,1,0-.55-89.43,63.31,63.31,0,0,0,.55,89.43Z" />
				</g>
			</g>
		</g>
	</svg>
);

export default SvgVazbyVyhledavani;